import { lookup } from 'country-data-list';

export function GetCurrencySymbol(name) {
    if (name === null || name === undefined) return null;

    return lookup?.currencies({ code: name })[0]?.symbol;
}

function Currency() {
    return null;
}

export default Currency;
